import {ApiConfigPort} from '../config/api-config-port';
import {HttpService} from '../../services/http-service';
import {ListResult, Result, UpdateResult} from './lib-rest';

export class FeatureFlagAdminApi {
  config: ApiConfigPort;


 public constructor(config: ApiConfigPort) {
    this.config = config;
  }

 public  async delete(key: string): Promise<UpdateResult>  {
const url =  new URL('/system/flags/' + key + '', this.config.host);

return (await HttpService.getAxiosClient().delete(url.toString())).data
  }

 public  async list(): Promise<ListResult<FeatureFlagAdminController$FeatureFlagJson> >  {
const url =  new URL('/system/flags', this.config.host);

return (await HttpService.getAxiosClient().get(url.toString())).data
  }

 public  async update(key: string, update: FeatureFlagAdminController$FeatureFlagUpdateJson): Promise<Result>  {
const url =  new URL('/system/flags/' + key + '', this.config.host);

return (await HttpService.getAxiosClient().put(url.toString(),JSON.stringify(update))).data
  }

}

export interface FeatureFlagAdminController$FeatureFlagJson {
  defaultValue: Object;
  key: string;
  overrideValue: Object;
}

export interface FeatureFlagAdminController$FeatureFlagUpdateJson {
  value: Object;
}

export class FeatureFlagApi {
  config: ApiConfigPort;


 public constructor(config: ApiConfigPort) {
    this.config = config;
  }

 public  async get(key: string): Promise<any>  {
const url =  new URL('/system/flags/' + key + '', this.config.host);

return (await HttpService.getAxiosClient().get(url.toString())).data
  }

}

